export default __webpack_public_path__ + "static/media/img1.10c6c8f7.png";